import React from 'react';
import { Box, Heading, Text, Stack, Center, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ConsolidadoNotas = () => {
    const navigate = useNavigate();
    const { sedeSeleccionada } = useSelector(state => state.auth);

    const handleClickPeriodo = () => {
        navigate(`/${sedeSeleccionada?._id}/consolidado-notas/periodo`, { state: { sedeId: sedeSeleccionada?._id } });
    };

    const handleClickGeneral = () => {
        navigate(`/${sedeSeleccionada?._id}/consolidado-notas/general`, { state: { sedeId: sedeSeleccionada?._id } });
    };

    return (
        <Center minH="76vh">
                {/* dos card uno consolidado notas por periodo y el otro general por año academico */}
                <Stack spacing={8} mb={8} align="center">
                    <Stack spacing={4} align="center">
                        <Heading as="h1" size="xl" color="primary.500" _dark={{ color: 'primary.200' }}>
                            Consolidado de Notas
                        </Heading>
                        <Text fontSize="lg" color="gray.600" _dark={{ color: 'gray.300' }}>
                            Aquí podrás visualizar el consolidado de notas por periodo y el consolidado general por año académico.
                        </Text>
                    </Stack>
                    <Stack direction={{ base: 'column', md: 'row' }} spacing={6}>
                        <Box
                            p={6}
                            borderWidth="1px"
                            borderRadius="lg"
                            boxShadow="md"
                            bg="white"
                            _dark={{ bg: 'gray.800' }}
                        >
                            <Heading as="h2" size="md" mb={4} color="primary.500" _dark={{ color: 'primary.200' }}>
                                Consolidado de Notas por Periodo
                            </Heading>
                            <Text fontSize="lg" color="gray.600" _dark={{ color: 'gray.300' }}>
                                Aquí podrás visualizar el consolidado de notas por periodo.
                            </Text>
                            <Button onClick={handleClickPeriodo} fontWeight={'normal'} mt={4} colorScheme="primary">Ver Consolidado por Periodo</Button>
                        </Box>
                        <Box
                            p={6}
                            borderWidth="1px"
                            borderRadius="lg"
                            boxShadow="md"
                            bg="white"
                            _dark={{ bg: 'gray.800' }}
                        >
                            <Heading as="h2" size="md" mb={4} color="primary.500" _dark={{ color: 'primary.200' }}>
                                Consolidado General por Año Académico
                            </Heading>
                            <Text fontSize="lg" color="gray.600" _dark={{ color: 'gray.300' }}>
                                Aquí podrás visualizar el consolidado general por año académico.
                            </Text>
                            <Button onClick={handleClickGeneral} fontWeight={'normal'} mt={4} colorScheme="primary">Ver Consolidado General</Button>
                        </Box>
                    </Stack>
                </Stack>
        </Center>
    );
};

export default ConsolidadoNotas;